import { Command } from 'commands/Commands';

export class ChangeMemberFacebookVisibility extends Command {
  type: string = 'Member.ChangeFacebookVisibility';
  priority = 100;
}
